<template>
    <div v-loading="loading">
        <div class="simple-row">
            <div class="left">
                <a class="swb-btn swb-btn-small" @click="toPrint">打印</a>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>请购信息</span>
            <div class="shrink-tab fr" :class="showRequireVoucherFlag ? 'current': ''" @click="doShowRequireVoucher()">
                <span>{{showRequireVoucherFlag ? '隐藏' : '展开'}}</span>
                <i :class="showRequireVoucherFlag ? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showRequireVoucherFlag">
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>请购单号</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span>{{requireVoucher.innerNo || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>请购总数量</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span>{{requireVoucher.goodsCount || 0}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>请购总金额(元)</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span>{{parseFloat(requireVoucher.wtxAmount || 0.00).toFixed(2)}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>购置部门</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span>{{requireVoucher.requireBizUnitName || ''}}/{{requireVoucher.requireComName || ''}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>购置公司</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span>{{requireVoucher.requireRealComName || ''}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>机构编号</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span>{{requireVoucher.requireComNo || ''}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>成本中心</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span>{{requireVoucher.costCenterCode || ''}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>利润中心</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span>{{requireVoucher.prftCenterCode || ''}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>申请人</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span>{{requireVoucher.applicantName || ''}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>电话</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span>{{requireVoucher.applicantContactTel || ''}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>申请部门</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span>{{requireVoucher.appliedBizUnitName || ''}}/{{requireVoucher.appliedComName || ''}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>经办人</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span>{{requireVoucher.applicantName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>申请日期</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span>{{requireVoucher.applyTime || ''}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>请购日期</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span>{{requireVoucher.requireDate || ''}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>标题</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span>{{requireVoucher.title || ''}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>采购需求</label>
                    </div>
                    <div :title="requireVoucher.desc" class="form-value width-1-5x ellipsis" style="white-space: nowrap;">
                        <span>{{requireVoucher.desc || ''}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>单独采购组装件</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span>{{requireVoucher.onlyForAsmblAcc ? '是' : '否'}}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="requireBackConfirm">
                    <div class="form-label">
                        <label>回溯确认岗</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span>{{requireVoucher.backConfirmPostName}}</span>
                    </div>
                </div>
            </div>
        </template>
        <div class="content-caption dashed" v-if="requireVoucher.goodsFlag">
            <span>请购商品</span>
            <div class="shrink-tab fr ml10" :class="showGoodsItemListFlag ? 'current': ''" @click="doShowGoodsItemList()">
                <span>{{showGoodsItemListFlag ? '隐藏' : '展开'}}</span>
                <i :class="showGoodsItemListFlag ? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
            <span class="fr" style="font-size: 12px">包含组装件总数：{{totalAsmblAccSetCount || 0}}</span>
            <span class="fr mr10" style="font-size: 12px">含税总金额(元)：{{parseFloat(requireVoucher.wtxAmount || 0).toFixed(2)}}</span>
        </div>
        <div class="table-layout" v-if="showGoodsItemListFlag && requireVoucher.goodsFlag">
            <div class="table-layout" style="overflow-x: auto">
                <table class="custom-tbl">
                    <thead class="head">
                    <tr class="row">
                        <th width="60">序号</th>
                        <th width="180" style="text-align: left">购置部门</th>
                        <th width="180" style="text-align: left" v-if="showAssetInfo">资产定义编码</th>
                        <th width="180" style="text-align: left" v-if="showAssetInfo">资产描述全称</th>
                        <th width="120" style="text-align: left" v-if="showAssetInfo">型号</th>
                        <th width="120" style="text-align: left" v-if="showAssetInfo">规格</th>
                        <th width="120" style="text-align: left" v-if="showAssetInfo">品牌</th>
                        <th width="180" style="text-align: left">名称</th>
                        <th width="120" style="text-align: left" v-if="!showAssetInfo">品牌名称</th>
                        <th width="120" style="text-align: left" v-if="!showAssetInfo">型号</th>
                        <th width="120" style="text-align: left" v-if="!showAssetInfo">规格</th>
                        <th width="100" style="text-align: right">申请数量</th>
                        <th width="110" style="text-align: right">含税价(元)</th>
                        <th width="110" style="text-align: right">含税小计(元)</th>
                        <th width="90" style="text-align: right">税率(%)</th>
                        <th width="180" style="text-align: left">供应商</th>
                        <th width="180" style="text-align: left">供方公司</th>
                        <th width="60">单位</th>
                        <th width="80">是否定制	</th>
                        <th width="120" style="text-align: left" v-if="showAssetInfo">资产分类名称</th>
                        <th width="120" style="text-align: left">分类名称</th>
                        <th width="80">仅组装件</th>
                        <th width="80">采购模式</th>
                        <th width="110" style="text-align: right">未税价(元)</th>
                        <th width="110" style="text-align: right">所需组装件数量</th>
                        <th width="110" style="text-align: right">包含组装件数量</th>
                        <th width="180" style="text-align: left">发货数量</th>
                        <th width="180" style="text-align: left">收货数量</th>
                    </tr>
                    </thead>
                    <tbody class="body" v-for="(goodsItem, index) in goodsItemList">
                    <tr class="row">
                        <td :rowspan="goodsItem.itemList.length + 1">
                            <span>{{index + 1}}</span>
                        </td>
                        <td style="text-align: left">
                            <span>{{goodsItem.requireComName || ''}}</span>
                        </td>
                        <td style="text-align: left" v-if="showAssetInfo">
                            <span>{{goodsItem.assetDefNo || ''}}</span>
                        </td>
                        <td style="text-align: left" v-if="showAssetInfo">
                            <span>{{goodsItem.devcTitle || ''}}</span>
                        </td>
                        <td style="text-align: left" v-if="showAssetInfo">
                            <span>{{goodsItem.devcModel || ''}}</span>
                        </td>
                        <td style="text-align: left" v-if="showAssetInfo">
                            <span>{{goodsItem.devcFixedSpec || ''}}</span>
                        </td>
                        <td style="text-align: left" v-if="showAssetInfo">
                            <span>{{goodsItem.devcBrandName || ''}}</span>
                        </td>

                        <td style="text-align: left">
                            <span v-if="showAssetInfo">{{goodsItem.devcName || ''}}</span>
                            <span v-else>{{goodsItem.name || ''}}</span>
                        </td>
                        <td style="text-align: left" v-if="!showAssetInfo">
                            <span>{{goodsItem.goodsBrandName || ''}}</span>
                        </td>
                        <td style="text-align: left" v-if="!showAssetInfo">
                            <span>{{goodsItem.model || ''}}</span>
                        </td>
                        <td style="text-align: left" v-if="!showAssetInfo">
                            <span>{{goodsItem.fixedSpec || ''}}</span>
                        </td>
                        <td style="text-align: right">
                            <span v-if="!goodsItem.onlyForAsmblAcc">{{goodsItem.quantity}}</span>
                        </td>
                        <td style="text-align: right">
                            <span v-if="goodsItem.price != null">{{goodsItem.price.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </td>
                        <td style="text-align: right">
                            <span v-if="goodsItem.wtxAmount != null">{{goodsItem.wtxAmount.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </td>
                        <td style="text-align: right">
                            <span v-if="goodsItem.taxRate != null">{{goodsItem.taxRate.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </td>
                        <td style="text-align: left">
                            <span>{{goodsItem.vendorName || ''}}</span>
                        </td>
                        <td style="text-align: left">
                            <span>{{goodsItem.vendorRealComName || ''}}</span>
                        </td>
                        <td>
                            <span v-if="showAssetInfo">{{goodsItem.devcUnit || ''}}</span>
                            <span v-else>{{goodsItem.unit || ''}}</span>
                        </td>
                        <td>
                            <span v-if="goodsItem.customized">是</span>
                            <span v-else>否</span>
                        </td>
                        <td style="text-align: left" v-if="showAssetInfo">
                            <span>{{ goodsItem.innerDevcCatName || '' }}</span>
                        </td>
                        <td style="text-align: left">
                            <span>{{goodsItem.goodsCatName || ''}}</span>
                        </td>

                        <td>
                            <span v-if="goodsItem.onlyForAsmblAcc">是</span>
                            <span v-else>否</span>
                        </td>
                        <td>
                            <span v-if="goodsItem.centBuyMode">集采</span>
                            <span v-else>自采</span>
                        </td>
                        <td style="text-align: right">
                            <span v-if="goodsItem.ntxPrice != null">{{goodsItem.ntxPrice.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </td>
                        <td style="text-align: right">
                            <span>{{goodsItem.asmblAccReqCount || 0}}</span>
                        </td>
                        <td style="text-align: right">
                            <span>{{goodsItem.asmblAccSetCount || 0}}</span>
                        </td>

                        <td style="text-align: right">
                            <span>{{goodsItem.shipQuantity}}</span>
                        </td>
                        <td style="text-align: right">
                            <span>{{goodsItem.recvQuantity}}</span>
                        </td>
                    </tr>
                    <tr class="row" v-for="(asmblAccItem, itemIndex) in goodsItem.itemList">
                        <td style="text-align: left">
                            <span>{{goodsItem.requireComName || ''}}</span>
                        </td>
                        <td style="text-align: left" v-if="showAssetInfo">
                            <span>{{asmblAccItem.accDefNo || ''}}</span>
                        </td>
                        <td style="text-align: left" v-if="showAssetInfo">
                            <span>{{asmblAccItem.devcTitle || ''}}</span>
                        </td>
                        <td style="text-align: left" v-if="showAssetInfo">
                            <span>{{asmblAccItem.devcModel || ''}}</span>
                        </td>
                        <td style="text-align: left" v-if="showAssetInfo">
                            <span>{{asmblAccItem.devcFixedSpec || ''}}</span>
                        </td>
                        <td style="text-align: left" v-if="showAssetInfo">
                            <span>{{asmblAccItem.devcBrandName || ''}}</span>
                        </td>

                        <td style="text-align: left">
                            <span v-if="showAssetInfo">{{asmblAccItem.devcName || ''}}</span>
                            <span v-else>{{asmblAccItem.name || ''}}</span>
                        </td>
                        <td style="text-align: left" v-if="!showAssetInfo">
                            <span>{{asmblAccItem.goodsBrandName || ''}}</span>
                        </td>
                        <td style="text-align: left" v-if="!showAssetInfo">
                            <span>{{asmblAccItem.model || ''}}</span>
                        </td>
                        <td style="text-align: left" v-if="!showAssetInfo">
                            <span>{{asmblAccItem.fixedSpec || ''}}</span>
                        </td>
                        <td style="text-align: right">
                            <span>{{asmblAccItem.quantity}}</span>
                        </td>
                        <td style="text-align: right">
                            <span v-if="asmblAccItem.price != null">{{asmblAccItem.price.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </td>
                        <td style="text-align: right">
                            <span v-if="asmblAccItem.wtxAmount != null">{{parseFloat(asmblAccItem.wtxAmount).toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </td>
                        <td style="text-align: right">
                            <span v-if="asmblAccItem.taxRate != null">{{asmblAccItem.taxRate.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </td>
                        <td style="text-align: left">
                            <span>{{asmblAccItem.vendorName || ''}}</span>
                        </td>
                        <td style="text-align: left">
                            <span>{{asmblAccItem.vendorRealComName || ''}}</span>
                        </td>
                        <td>
                            <span v-if="showAssetInfo">{{asmblAccItem.devcUnit || ''}}</span>
                            <span v-else>{{asmblAccItem.unit || ''}}</span>
                        </td>
                        <td>
                            <span></span>
                        </td>
                        <td style="text-align: left" v-if="showAssetInfo">
                            <span>{{ goodsItem.innerDevcCatName || '' }}</span>
                        </td>
                        <td style="text-align: left">
                            <span>{{asmblAccItem.goodsCatName || ''}}</span>
                        </td>
                        <td>
                            <span></span>
                        </td>
                        <td>
                            <span></span>
                        </td>
                        <td style="text-align: right">
                            <span v-if="asmblAccItem.ntxPrice != null">{{asmblAccItem.ntxPrice.toFixed(2)}}</span>
                            <span v-else>0.00</span>
                        </td>
                        <td></td>
                        <td></td>
                        <td style="text-align: left"></td>
                        <td style="text-align: left"></td>
                    </tr>
                    </tbody>

                    <tbody class="body" v-if="goodsItemList == null || goodsItemList.length <= 0">
                    <tr class="row">
                        <td colspan="16" style="text-align: center; line-height: 40px;">
                            <span>暂无数据...</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="content-caption dashed" v-if="requireVoucher.servcFlag">
            <span>请购服务</span>
            <div class="shrink-tab fr" :class="showServcItemListFlag ? 'current': ''" @click="doShowServcItemList()">
                <span>{{showServcItemListFlag ? '隐藏' : '展开'}}</span>
                <i :class="showServcItemListFlag ? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <div class="table-layout" v-if="showServcItemListFlag && requireVoucher.servcFlag">
            <el-table :data="servcItemList" border max-height="400" style="width: 100%">
                <el-table-column prop="name" label="服务名称" fixed min-width="200"></el-table-column>
                <el-table-column prop="requireComName" label="购置部门" width="250"></el-table-column>
                <el-table-column prop="servcCatName" label="分类名称" width="150"></el-table-column>
                <el-table-column prop="servcBrandName" label="品牌名称" width="150"></el-table-column>
                <el-table-column prop="desc" label="描述" min-width="300"></el-table-column>
            </el-table>
        </div>
        <div class="content-caption dashed" v-if="fileList.length > 0">
            <span>附件管理</span>
            <div class="shrink-tab fr" :class="showFileItemFlag ? 'current': ''" @click="doShowFileItem()">
                <span>{{showFileItemFlag ? '隐藏' : '展开'}}</span>
                <i :class="showFileItemFlag ? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showFileItemFlag && fileList.length > 0">
            <div class="file-view-list">
                <div class="file-view-header">
                    <div class="file-name">名称</div>
                    <div class="file-opera">操作</div>
                </div>
                <template v-for="(fileInfo, index) in fileList">
                    <swb-file-item-li :trackKey="index" :fileName="fileInfo.name" :fileBrowseUrl="fileInfo.fileBrowseUrl" :fileDownloadUrl="fileInfo.fileBrowseUrl" :fileUuid="fileInfo.fileUuid" :deletable="false"></swb-file-item-li>
                </template>
            </div>
        </template>
        <div class="content-caption dashed">
            <span>审核记录</span>
            <div class="shrink-tab fr" :class="showOaAuditFlag ? 'current': ''" @click="doShowOaAuditInfo()">
                <span>{{showOaAuditFlag ? '隐藏' : '展开'}}</span>
                <i :class="showOaAuditFlag ? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showOaAuditFlag">
            <swb-device-require-audit-rec-list v-if="requireVoucher.id != null && !requireVoucher.outerAuditFlag" :item="requireVoucher.id" ref="swb_device_require_audit_rec_list"></swb-device-require-audit-rec-list>
            <template v-if="requireVoucher.id != null && requireVoucher.outerAuditFlag">
                <swb-oa-audit-rec-list bizTypeCode="retailer.assets.purch" :bizVoucherNo="bizVoucherNo" :auditSeqNo="requireVoucher.auditSeqNo" ref="swb_oa_audit_rec_list"></swb-oa-audit-rec-list>
            </template>
        </template>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getMerchantBizParam } from '../asset/assetMain'

    import devcReqrApi from '../../api/devcReqr'

    import swbDeviceRequireAuditRecList from './DeviceRequireAuditRecList.vue'
    Vue.regist(swbDeviceRequireAuditRecList);

    import AuditBpRecsList from '../oaAudit/AuditBpRecsList.vue';
    Vue.regist(AuditBpRecsList);

    import SwbFileItemLi from '../ctrl/FileItemLi';
    Vue.regist(SwbFileItemLi);

    export default {
        name: 'swb-require-goods-item-list',
        desc: '设备请购单项列表',
        props: ['item'],
        data: function () {
            return {
                loading: true,
                goodsItemList: [],
                servcItemList: [],
                itemList: null,
                id: null,
                applyTime: null,
                applyDesc: null,
                requireVoucher: {},
                totalAsmblAccSetCount: 0,
                requireBackConfirm: false,
                requireTotalAmount: 0,    // 请购总金额
                fileList: [],    // 附件
                bizVoucherNo: null,
                showRequireVoucherFlag: true,
                showFileItemFlag: true,
                showGoodsItemListFlag: true,
                showServcItemListFlag: true,
                showOaAuditFlag: true,
                showAssetInfo: false,
            }
        },

        created: function () {
            let self = this;
            // 交易中是否展示资产相关信息
            getMerchantBizParam("display.asset.related.info.in.trading", function (result) {
                self.showAssetInfo = Utils.isTrue(result);
            });
            getMerchantBizParam("purch.accecpt.require.back.confirm", function (result) {
                self.requireBackConfirm = Utils.isTrue(result);
            });
            //
            this.getRequireGoodsItem();
        },
        methods: {
            getRequireGoodsItem: function () {
                let self = this;
                let postData = {};
                postData.id = self.item;
                devcReqrApi.getDeviceRequireVoucherInfo(postData, function (result) {
                    if(result.type === "info") {
                        let requireVoucher = result.data;
                        if(requireVoucher != null) {
                            self.bizVoucherNo = requireVoucher.no;
                            if(!Utils.isNoB(requireVoucher.innerNo)) {
                                self.bizVoucherNo = requireVoucher.innerNo;
                            }
                            //
                            self.goodsItemList = requireVoucher.goodsItemList || [];
                            self.servcItemList = requireVoucher.servcItemList || [];
                            // 统计数量
                            let requireTotalAmount = 0.00;
                            self.goodsItemList.forEach(function (item) {
                                requireTotalAmount += item.quantity * item.price;
                                if(!Utils.isNoB(item.itemList) && item.itemList.length > 0) {
                                    item.itemList.forEach(function (itemInfo) {
                                        requireTotalAmount += itemInfo.quantity * itemInfo.price;
                                    });
                                }
                            });
                            self.requireTotalAmount = requireTotalAmount.toFixed(2);
                            //
                            self.countTotalAsmblAccSetCount();
                            // 附件
                            self.getAdjustApplyFormFileList(requireVoucher.id);
                        }
                        self.requireVoucher = requireVoucher;
                        //
                        self.loading = false;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            countTotalAsmblAccSetCount(){
                let goodsItemList = this.goodsItemList || [];
                let totalAsmblAccSetCount = 0;
                goodsItemList.forEach(function (theItem) {
                    totalAsmblAccSetCount = totalAsmblAccSetCount + theItem.asmblAccSetCount;
                });
                this.totalAsmblAccSetCount = totalAsmblAccSetCount;
            },
            // 附件
            getAdjustApplyFormFileList: function (voucherId) {
                let self = this;
                let postData = {
                    voucherId: voucherId
                };
                let theLoad = MsgBox.loading();
                devcReqrApi.getDeviceRequireFileList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        //
                        self.fileList = result.data || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },

            // 展开/隐藏
            doShowRequireVoucher: function () {
                this.showRequireVoucherFlag = !this.showRequireVoucherFlag;
            },
            // 展开/隐藏
            doShowFileItem: function () {
                this.showFileItemFlag = !this.showFileItemFlag;
            },
            // 展开/隐藏
            doShowGoodsItemList: function () {
                this.showGoodsItemListFlag = !this.showGoodsItemListFlag;
            },
            // 展开/隐藏
            doShowServcItemList: function () {
                this.showServcItemListFlag = !this.showServcItemListFlag;
            },
            // 展开/隐藏
            doShowOaAuditInfo: function () {
                this.showOaAuditFlag = !this.showOaAuditFlag;
            },
            toPrint(){
                let collapsedBlocks = [];

                if(!this.showRequireVoucherFlag) {
                    collapsedBlocks.push('requireVoucher');
                }
                if(!this.showGoodsItemListFlag) {
                    collapsedBlocks.push('goodsItemList');
                }
                if(!this.showServcItemListFlag) {
                    collapsedBlocks.push('servcItemList');
                }
                if(!this.showFileItemFlag) {
                    collapsedBlocks.push('fileList');
                }
                if(!this.showOaAuditFlag) {
                    collapsedBlocks.push('actRecList');
                    collapsedBlocks.push('oaRecList');
                }

                let requireVoucher = this.requireVoucher;
                let url = '/voucher/print/jsp';
                let postData = {
                    bizType: 'biz.proof.zichan.qinggou',
                    voucherId: requireVoucher.id,
                    collapsedBlocks: collapsedBlocks.join(',')
                };
                let printUrl = Utils.makeUrl(getAppUrl(url), postData);
                Utils.setPageUrl(printUrl, '_blank');
            }

        }
    }
</script>

<style>
    .el-table .row-expand-cover .cell .el-table__expand-icon {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/compo/retailer/RequireGoodsItemList.vue